interface SharePropsBase {
  url: string;
  windowWidth?: number;
  windowHeight?: number;
}

type TwitterShareProps = SharePropsBase & {
  text?: string;
};

export function openTwitterShareWindow({
  url: targetUrl,
  text,
  windowWidth = 500,
  windowHeight = 400,
}: TwitterShareProps) {
  const url = `http://twitter.com/intent/tweet?url=${encodeURIComponent(targetUrl)}${
    text ? `&text=${encodeURIComponent(text)}` : ""
  }`;
  window.open(url, "", `width=${windowWidth}, height=${windowHeight}`);
}

export function openFacebookShareWindow({ url: targetUrl, windowWidth = 500, windowHeight = 400 }: SharePropsBase) {
  const url = `http://www.facebook.com/sharer.php?u=${encodeURIComponent(targetUrl)}`;
  window.open(url, "", `width=${windowWidth}, height=${windowHeight}`);
}



// WEBPACK FOOTER //
// ./frontend/src/common/utils/sns.ts